import { useHistory } from "react-router-dom";
import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";
import { useEmailMarketingTemplatePaths } from "@/react/components/shared/Emails/Templates/TemplatePathContext";
import { TEMPLATES_MODAL_ID } from "@/react/components/shared/Emails/Templates/TemplatesModal";
import { Form } from "@/react/components/shared/uikit/Form";
import { Modal } from "@/react/components/shared/uikit/ModalV2";
import { ModalBody } from "./ModalBody";
import { ModalFooter } from "./ModalFooter";
import { ModalHeader } from "./ModalHeader";

export type Editor = "visual" | "text" | null;

export const EDITOR_SELECTION_MODAL_ID =
  "broadcast-editor-selection-modal" as const;

const EditorSelectionModalComponent = () => {
  const history = useHistory();
  const modal = useModal();
  const templateSelectionModal = useModal(TEMPLATES_MODAL_ID);
  const { visualBuilderPath, contentPath } = useEmailMarketingTemplatePaths();

  const handleSubmit = (data: { editor: Editor }) => {
    const path = data.editor === "visual" ? visualBuilderPath : contentPath;

    history.push(path);
    void modal.hide();
    void templateSelectionModal.hide();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Modal isOpen={modal.visible} onClose={modal.hide}>
      <Modal.Overlay />
      <Modal.Content size="lg" wrapperClassName="!h-full">
        <Form
          onSubmit={handleSubmit}
          defaultValues={{ editor: null }}
          shouldStopPropagation
          onKeyDown={handleKeyDown}
        >
          <ModalHeader onClose={modal.hide} />
          <ModalBody />
          <ModalFooter onClose={modal.hide} />
        </Form>
      </Modal.Content>
    </Modal>
  );
};

export const EditorSelectionModal = ModalManager.create(
  EditorSelectionModalComponent,
);
